/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShopOrderItem } from './ShopOrderItem';
import {
  ShopOrderItemFromJSON,
  ShopOrderItemFromJSONTyped,
  ShopOrderItemToJSON,
} from './ShopOrderItem';
import type { CourierUser } from './CourierUser';
import {
  CourierUserFromJSON,
  CourierUserFromJSONTyped,
  CourierUserToJSON,
} from './CourierUser';

/**
 *
 * @export
 * @interface ShopOrder
 */
export interface ShopOrder {
  /**
   *
   * @type {number}
   * @memberof ShopOrder
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof ShopOrder
   */
  courierId?: number;
  /**
   *
   * @type {number}
   * @memberof ShopOrder
   */
  customerId?: number;
  /**
   *
   * @type {string}
   * @memberof ShopOrder
   */
  status?: string;
  /**
   *
   * @type {number}
   * @memberof ShopOrder
   */
  totalAmount?: number;
  /**
   *
   * @type {string}
   * @memberof ShopOrder
   */
  paymentMethod?: string;
  /**
   *
   * @type {string}
   * @memberof ShopOrder
   */
  paymentStatus?: string;
  /**
   *
   * @type {string}
   * @memberof ShopOrder
   */
  paymentReference?: string;
  /**
   *
   * @type {string}
   * @memberof ShopOrder
   */
  proofOfPayment?: string;
  /**
   *
   * @type {string}
   * @memberof ShopOrder
   */
  notes?: string;
  /**
   *
   * @type {string}
   * @memberof ShopOrder
   */
  guestName?: string;
  /**
   *
   * @type {string}
   * @memberof ShopOrder
   */
  guestEmail?: string;
  /**
   *
   * @type {string}
   * @memberof ShopOrder
   */
  guestPhone?: string;
  /**
   *
   * @type {boolean}
   * @memberof ShopOrder
   */
  isGuestOrder?: boolean;
  /**
   *
   * @type {Date}
   * @memberof ShopOrder
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof ShopOrder
   */
  updatedAt?: Date;
  /**
   *
   * @type {Array<ShopOrderItem>}
   * @memberof ShopOrder
   */
  items?: Array<ShopOrderItem>;
  /**
   *
   * @type {CourierUser}
   * @memberof ShopOrder
   */
  courierUser?: CourierUser;
  customer?: any;
}

/**
 * Check if a given object implements the ShopOrder interface.
 */
export function instanceOfShopOrder(
  value: object
): value is ShopOrder {
  return true;
}

export function ShopOrderFromJSON(json: any): ShopOrder {
  return ShopOrderFromJSONTyped(json, false);
}

export function ShopOrderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ShopOrder {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    customerId: json['customerId'] == null ? undefined : json['customerId'],
    status: json['status'] == null ? undefined : json['status'],
    totalAmount: json['totalAmount'] == null ? undefined : json['totalAmount'],
    paymentMethod: json['paymentMethod'] == null ? undefined : json['paymentMethod'],
    paymentStatus: json['paymentStatus'] == null ? undefined : json['paymentStatus'],
    paymentReference: json['paymentReference'] == null ? undefined : json['paymentReference'],
    proofOfPayment: json['proofOfPayment'] == null ? undefined : json['proofOfPayment'],
    notes: json['notes'] == null ? undefined : json['notes'],
    guestName: json['guestName'] == null ? undefined : json['guestName'],
    guestEmail: json['guestEmail'] == null ? undefined : json['guestEmail'],
    guestPhone: json['guestPhone'] == null ? undefined : json['guestPhone'],
    isGuestOrder: json['isGuestOrder'] == null ? undefined : json['isGuestOrder'],
    createdAt: json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    updatedAt: json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
    items: json['items'] == null ? undefined : (json['items'] as Array<any>).map(ShopOrderItemFromJSON),
    courierUser: json['courierUser'] == null ? undefined : CourierUserFromJSON(json['courierUser']),
    customer: json['customer'] == null ? undefined : json['customer'],
  };
}

export function ShopOrderToJSON(json: any): ShopOrder {
  return ShopOrderToJSONTyped(json, false);
}

export function ShopOrderToJSONTyped(
  value?: ShopOrder | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    courierId: value['courierId'],
    customerId: value['customerId'],
    status: value['status'],
    totalAmount: value['totalAmount'],
    paymentMethod: value['paymentMethod'],
    paymentStatus: value['paymentStatus'],
    paymentReference: value['paymentReference'],
    proofOfPayment: value['proofOfPayment'],
    notes: value['notes'],
    guestName: value['guestName'],
    guestEmail: value['guestEmail'],
    guestPhone: value['guestPhone'],
    isGuestOrder: value['isGuestOrder'],
    createdAt: value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    updatedAt: value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
    items: value['items'] == null ? undefined : (value['items'] as Array<any>).map(ShopOrderItemToJSON),
    courierUser: CourierUserToJSON(value['courierUser']),
    customer: value['customer'],
  };
}
